import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { forexApi, type SubscriptionAuthorizationDTO } from '@/services/forexApi';
import { authorizationLabel, readinessLabel } from '@/lib/followPresentation';

export default function SubscriptionStatus({ relationId, agentId, revision = 0 }: {
  relationId: string; agentId: string | number; revision?: number;
}) {
  const { accessToken } = useAuth();
  const [value, setValue] = useState<SubscriptionAuthorizationDTO>();
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    let active = true;
    setValue(undefined); setError(false); setLoading(true);
    if (!accessToken) { setLoading(false); return; }
    void forexApi.getSubscriptionAuthorization(relationId, accessToken)
      .then(result => { if (active) setValue(result); })
      .catch(() => { if (active) setError(true); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [relationId, accessToken, revision, retry]);
  return <section aria-label="策略授权状态" className="mt-3 rounded-xl bg-indigo-50/50 p-3 text-sm">
    <p role={loading ? 'status' : undefined} className="font-medium text-gray-800">{loading ? '正在读取授权状态…' : authorizationLabel(value)}</p>
    {!loading && <p className="mt-1 text-xs leading-relaxed text-gray-600">{readinessLabel(value)}</p>}
    {error && <button type="button" onClick={() => setRetry(n => n + 1)} className="min-h-11 text-indigo-600">重试授权状态</button>}
    {value?.readiness === 'needs_reauthorization' && <Link to={`/copy-config?agentId=${encodeURIComponent(agentId)}`} className="inline-flex min-h-11 items-center font-medium text-indigo-600">查看新策略并授权</Link>}
  </section>;
}
